<template>
  <div>
    <div class="NewAdd">
      <el-button
        class="NewAddBtn"
        type="primary"
        icon="el-icon-plus"
        @click="NewAddBtn"
        >新建</el-button
      >
    </div>
    <el-table ref="multipleTable" :data="tableData" style="width: 100%" lazy>
      <el-table-column prop="Name" label="LOGO">
        <template slot-scope="scope">
          <div class="channel">
            <img src="../../image/youjia.png" alt="" />
            <div class="channel_name">{{ scope.row.status }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="门店名称"> </el-table-column>
      <el-table-column prop="address" label="地址"> </el-table-column>
      <el-table-column prop="operationTel" label="运营电话"> </el-table-column>
      <el-table-column label="是否闪订">
        <template slot-scope="scope">
          <div v-if="scope.row.is_instant_confirm == 1">是</div>
          <div v-if="scope.row.is_instant_confirm == 0">否</div>
        </template>
      </el-table-column>
      <el-table-column label="无责任取消">
        <template slot-scope="scope">
          <div v-if="scope.row.cancelWithoutDuty == 1">是</div>
          <div v-if="scope.row.cancelWithoutDuty == 0">否</div>
        </template>
      </el-table-column>
      <el-table-column prop="creationTime" label="编辑时间"> </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <div v-if="scope.row.active == 0" style="color:#F62A2A">未上线</div>
          <div v-if="scope.row.active == 1" style="color:#219653">已上线</div>
        </template>
      </el-table-column>
      <el-table-column prop="Name" label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            class="operation_right"
            @click="LookBtn(scope.row)"
            >查看</el-button
          >
          <el-button
            type="text"
            class="operation_right"
            @click="compile(scope.row)"
            >编辑</el-button
          >
          <!-- <el-button type="text" style="color:#F62A2A" @click="Delete()"
            >删除</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 新建弹窗 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="750px"
      :before-close="handleClose"
    >
      <!-- 上传图片 -->
      <div class="upimg">
        <div class="upimg_box">
          <el-upload
            ref="my-upload"
            :limit="1"
            :headers="headers"
            name="avatarfile"
            :action="baseURL"
            list-type="picture-card"
            :on-success="vCoverPicSuccessFour"
            :on-remove="vCoverPicRemove"
            :before-upload="beforeAvatarUpload"
            :file-list="vCoverPicSuccess"
          >
            <!-- <i class="el-icon-plus">添加照片</i>   :on-preview="vCoverPicCardPreview" :file-list="vCoverPicSuccess"-->
            <i class="el-icon-plus"></i>
          </el-upload>
          <!-- <el-dialog :visible.sync="vCoverPicLook_img">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog> -->
        </div>
      </div>
      <el-form :model="formList" ref="formList" label-width="110px">
        <el-form-item
          label="名称："
          prop="name"
          :rules="[{ required: true, message: '请输入名称', trigger: 'blur' }]"
        >
          <el-input
            v-model="formList.name"
            placeholder="请输入门店名称"
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          label="门店简介："
          prop="instruction"
          :rules="[
            { required: true, message: '请输入门店介绍', trigger: 'blur' }
          ]"
        >
          <el-input
            class="synopsis"
            type="textarea"
            resize="none"
            v-model="formList.instruction"
            placeholder="请输入门店介绍"
            maxlength="2014"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          label="欢迎词："
          prop="welcomes"
          :rules="[
            { required: true, message: '请输入欢迎词', trigger: 'blur' }
          ]"
        >
          <el-input
            class="salutatory"
            type="textarea"
            resize="none"
            placeholder="请输入欢迎词"
            v-model="formList.welcomes"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          label="门店地址："
          prop="address"
          :rules="[
            {
              required: true,
              message: '请输入门店地址',
              trigger: 'change'
            }
          ]"
        >
          <el-input
            readonly
            @focus="dialogFormVisible = true"
            placeholder="请输入门店地址"
            v-model="formList.address"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="联系电话："
          prop="tel"
          :rules="[
            { required: true, message: '请输入联系电话', trigger: 'blur' }
          ]"
        >
          <el-input
            v-model="formList.tel"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="运营电话：">
          <el-input
            v-model="formList.operationTel"
            placeholder="无，则同联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="联系邮件："
          prop="email"
          :rules="[
            { required: true, message: '请输入邮箱地址', trigger: 'blur' },
            {
              type: 'email',
              message: '请输入正确的邮箱地址',
              trigger: ['blur', 'change']
            }
          ]"
        >
          <el-input
            placeholder="请输入邮箱"
            v-model="formList.email"
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          label="接单时间："
          prop="ordernon_endtime"
          :rules="[
            { required: true, message: '请选择结束时间', trigger: 'blur' }
          ]"
        >
          <el-time-select
            placeholder="起始时间"
            v-model="formList.ordernon_starttime"
            :picker-options="{
              start: '00:00',
              step: '00:30',
              end: '23:30'
            }"
          >
          </el-time-select>
          ——
          <el-time-select
            placeholder="结束时间"
            v-model="formList.ordernon_endtime"
            :picker-options="{
              start: '00:00',
              step: '00:30',
              end: '23:30',
              minTime: formList.ordernon_starttime
            }"
          >
          </el-time-select>
        </el-form-item>
        <el-form-item>
          <!-- <div class="Radio_box">
            <div class="Radio" v-for="item in 5" :key="item" @click="Radio_btn">
              <div class="Radio_left" v-if="item % 2 == 0"></div>
              <div class="Radio_left_yes" v-else></div>
              <div class="Radio_right">是否支持30m无责任取消</div>
            </div>
          </div> -->
          <div class="Radio_box">
            <el-checkbox
              v-model="formList.is_instant_confirm"
              label="是否闪订"
              border
            ></el-checkbox>
            <el-checkbox
              v-model="formList.cancelWithoutDuty"
              label="是否支持30m无责任取消"
              border
            ></el-checkbox>
            <el-checkbox
              v-model="formList.acceptBreachUser"
              label="是否接待失信房客"
              border
            ></el-checkbox>
            <el-checkbox
              v-model="formList.hasFrontDesk"
              label="是否有前台"
              border
            ></el-checkbox>
            <el-checkbox
              v-model="formList.active"
              label="是否上线"
              border
            ></el-checkbox>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel" @click="cancel('formList')">取 消</el-button>
        <el-button
          type="primary"
          @click="newHotels('formList')"
          class="add_new_btn"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 选择地点 -->
    <el-dialog
      title="选择房源地址"
      width="750px"
      :visible.sync="dialogFormVisible"
    >
      <el-form :model="formMap" ref="ruleForm">
        <el-form-item
          label="省/市/区："
          label-width="140px"
          style="color:#000000"
          prop="cityValue"
          :rules="[
            { required: true, message: '省/市/区不能为空', trigger: 'change' }
          ]"
        >
          <el-cascader
            clearable
            :props="cityProps"
            v-model="formMap.cityValue"
            :options="cityOptions"
            @change="handleChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址：" label-width="140px">
          <div class="form_item">
            <div class="form_item_title">
              无需再填省/市/区。例：卓尔企业社区H9栋3楼
            </div>
          </div>
          <el-autocomplete
            v-model="formMap.address"
            :fetch-suggestions="querySearch"
            placeholder="请输入详细地址"
            style="width: 100%"
            :trigger-on-focus="false"
            @select="handleSelect"
          />
        </el-form-item>
        <el-form-item label="门牌号：" label-width="140px">
          <div class="form_item">
            <div class="form_item_title">
              房客不可见。例：201房
            </div>
          </div>
          <el-input v-model="formMap.location"></el-input>
        </el-form-item>
        <el-form-item label="地图上的位置：" label-width="140px">
          <baidu-map
            class="map"
            :center="this.frameCenter"
            :zoom="this.zoom"
            @ready="handlerBMap"
          >
            <!-- 放大缩小 -->
            <bm-navigation
              type="BMAP_NAVIGATION_CONTROL_SMALL"
              anchor="BMAP_ANCHOR_TOP_RIGHT"
            ></bm-navigation>
            <!-- 标记点 -->
            <bm-marker
              :position="{ lng: markers.lng, lat: markers.lat }"
              :dragging="true"
              @dragend="getMapCenter"
            >
            </bm-marker>
          </baidu-map>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleCancel('ruleForm')"
          >取 消</el-button
        >
        <el-button type="primary" @click="dialogFormVisibleBtn('ruleForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 查看 -->
    <el-dialog
      title="查看"
      :visible.sync="dialogLook"
      width="750px"
      :before-close="handleClose"
    >
      <div class="Storeimage">
        <img :src="LookList.logo" alt="" />
      </div>
      <p class="StoreName">{{ LookList.name }}</p>
      <div class="StoreInfo">
        <div class="StoreInfo_title">门店简介：</div>
        <div class="StoreInfo_message">
          {{ LookList.instruction }}
        </div>
      </div>
      <div class="StoreInfo">
        <div class="StoreInfo_title">欢迎词：</div>
        <div class="StoreInfo_message">
          {{ LookList.welcomes }}
        </div>
      </div>
      <div class="StoreInfo">
        <div class="StoreInfo_title">门店地址：</div>
        <div class="StoreInfo_message">
          {{ LookList.address }}
        </div>
      </div>
      <div class="StoreInfo">
        <div class="StoreInfo_title">联系电话：</div>
        <div class="StoreInfo_message">
          {{ LookList.tel }}
        </div>
      </div>
      <div class="StoreInfo">
        <div class="StoreInfo_title">运营电话：</div>
        <div class="StoreInfo_message">
          {{ LookList.operationTel }}
        </div>
      </div>
      <div class="StoreInfo">
        <div class="StoreInfo_title">联系邮件：</div>
        <div class="StoreInfo_message">
          {{ LookList.email }}
        </div>
      </div>
      <div class="StoreInfo">
        <div class="StoreInfo_title">接单时间：</div>
        <div class="StoreInfo_message">
          {{ LookList.ordernon_starttime }}-{{ LookList.ordernon_endtime }}
        </div>
      </div>
      <div class="RadioBox">
        <el-checkbox
          v-model="LookList.is_instant_confirm"
          label="是否闪订"
          border
          disabled
        ></el-checkbox>
        <el-checkbox
          v-model="LookList.cancelWithoutDuty"
          label="是否支持30m无责任取消"
          border
          disabled
        ></el-checkbox>
        <el-checkbox
          v-model="LookList.acceptBreachUser"
          label="是否接待失信房客"
          border
          disabled
        ></el-checkbox>
        <el-checkbox
          v-model="LookList.hasFrontDesk"
          label="是否有前台"
          border
          disabled
        ></el-checkbox>
        <el-checkbox
          v-model="LookList.active"
          label="是否上线"
          border
          disabled
        ></el-checkbox>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import axios from "axios";
import {
    updateTJStore,
    getStore,
    getStoreHid, addTjHousing
} from "../../api/index";
export default {
  components: {
    BaiduMap
  },
  filters: {
    phone: function(item) {
      if (item == null) return;
      return item.substr(0, 3) + "****" + item.substr(7);
    }
  },
  data() {
    return {
      Isgo: true,
      vCoverPicSuccess: [],
      title: "新建门店",
      baseURL: "https://test.youjiaminsu.cn:333/system/user/profile/housePic", //线上
      URL: "http://192.168.18.121:8808/system/user/profile/housePic", //本地的
      startTime: "",
      endTime: "",
      mapLocation: {
        address: undefined,
        coordinate: undefined
      },
      // 地图缩放
      zoom: 1,
      // 点的经纬度
      markers: {
        lng: undefined,
        lat: undefined
      },

      frameCenter: "中国",
      cityValue: "中国",
      dialogImageUrl: "",
      dialogVisibleImg: false,
      dialogFormVisible: false,
      dialogVisible: false,
      dialogLook: false,
      vCoverPicLook_img: false,

      tableData: [],
      formList: {
        // hotels: {
        //   acceptBreachUser: false, //是否接待失信用户
        //   active: false, //是否上线
        //   address: "", //门店地址
        //   cancelWithoutDuty: false, //是否支持30min无责取消
        //   email: "", //联系邮件
        //   hasFrontDesk: false, //是否有前台
        //   instruction: "", //门店简介
        //   is_instant_confirm: false, //是否开启闪订
        //   logo: "", //logoImg
        //   latitude: undefined, //纬度
        //   longtitude: undefined, //经度
        //   name: "", //门店名称
        //   operationTel: "", //运营电话
        //   ordernon_endtime: "", //结束时间
        //   ordernon_starttime: "", //开始时间
        //   tel: "", //联系电话
        //   welcomes: "" //门店欢迎词
        // }
        acceptBreachUser: false, //是否接待失信用户
        active: false, //是否上线
        address: "", //门店地址
        cancelWithoutDuty: false, //是否支持30min无责取消
        email: "", //联系邮件
        hasFrontDesk: false, //是否有前台
        instruction: "", //门店简介
        is_instant_confirm: false, //是否开启闪订
        logo: "", //logoImg
        latitude: undefined, //纬度
        longtitude: undefined, //经度
        name: "", //门店名称
        operationTel: "", //运营电话
        ordernon_endtime: "", //结束时间
        ordernon_starttime: "00:00", //开始时间
        tel: "", //联系电话
        welcomes: "" //门店欢迎词
      },
      formMap: {
        province: "", //省
        city: "", //市
        district: "", //区
        address: "", //地址
        location: "" //门牌号
      },
      // 级联选择器数据
      cityOptions: [],
      cityProps: {
        value: "name",
        label: "name",
        children: "districts"
        // expandTrigger: "hover",
      },
      LookList: [],
      Radio_list: [],
      checkboxGroup: [],
      Store: {
        pageNum: 1,
        pageSize: 5
      },
      temporaryAddress: ""
    };
  },
  created() {
    this.getMapList();
    this.getStoreList();
  },
  computed: {
    headers() {
      return {
        Authorization: "Bearer " + this.$store.state.user // 直接从本地获取token就行
      };
    }
  },
  methods: {
    // 关闭新建弹窗
    cancel(formName) {
      this.dialogVisible = false;
      this.formList = {
        acceptBreachUser: false, //是否接待失信用户
        active: false, //是否上线
        address: "", //门店地址
        cancelWithoutDuty: false, //是否支持30min无责取消
        email: "", //联系邮件
        hasFrontDesk: false, //是否有前台
        instruction: "", //门店简介
        is_instant_confirm: false, //是否开启闪订
        logo: "", //logoImg
        latitude: undefined, //纬度
        longtitude: undefined, //经度
        name: "", //门店名称
        operationTel: "", //运营电话
        ordernon_endtime: "", //结束时间
        ordernon_starttime: "00:00", //开始时间
        tel: "", //联系电话
        welcomes: "" //门店欢迎词
      };
      this.$refs[formName].resetFields();
    },
    // 新建门店确认按钮
    newHotels(formName) {
      if (this.title == "新建门店") {
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.formList.logo == "")
              return this.$message({
                type: "error",
                message: "请添加门店图片!"
              });
            if (!this.Isgo) return;
            this.Isgo == false;
            this.formList.ordernon_starttime = `${this.formList.ordernon_starttime}:00`;
            this.formList.ordernon_endtime = `${this.formList.ordernon_endtime}:00`;
            this.AddTjHotelPost(formName);
            this.$refs[formName].resetFields();
          } else {
            return false;
          }
        });
      } else {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.formList.ordernon_starttime = `${this.formList.ordernon_starttime}:00`;
            this.formList.ordernon_endtime = `${this.formList.ordernon_endtime}:00`;
            this.updateTJStoreGet();
            this.$nextTick(() => {
              this.$refs[formName].resetFields();
            });
          } else {
            return false;
          }
        });
      }
    },
    // 编辑途家门确定按钮
    async updateTJStoreGet(formName) {
      const { data: res } = await updateTJStore(this.formList);
      if (res.code !== 200)
        return this.$message({
          type: "error",
          message: res.msg
        });
      this.$message({
        type: "success",
        message: "修改成功!"
      });

      this.dialogVisible = false;
      this.formList = {
        acceptBreachUser: false, //是否接待失信用户
        active: false, //是否上线
        address: "", //门店地址
        cancelWithoutDuty: false, //是否支持30min无责取消
        email: "", //联系邮件
        hasFrontDesk: false, //是否有前台
        instruction: "", //门店简介
        is_instant_confirm: false, //是否开启闪订
        logo: "", //logoImg
        latitude: undefined, //纬度
        longtitude: undefined, //经度
        name: "", //门店名称
        operationTel: "", //运营电话
        ordernon_endtime: "", //结束时间
        ordernon_starttime: "00:00", //开始时间
        tel: "", //联系电话
        welcomes: "" //门店欢迎词
      };
      this.getStoreList();
      this.$refs[formName].resetFields();
    },
    // 新建途家门店
    async AddTjHotelPost() {
      const { data: res } = await addTjHousing(this.formList);
      if (res.code !== 200)
        return this.$message({
          type: "error",
          message: res.msg
        });

      this.$message({
        type: "success",
        message: "新建成功!"
      });
      this.dialogVisible = false;
      this.formList = {
        acceptBreachUser: false, //是否接待失信用户
        active: false, //是否上线
        address: "", //门店地址
        cancelWithoutDuty: false, //是否支持30min无责取消
        email: "", //联系邮件
        hasFrontDesk: false, //是否有前台
        instruction: "", //门店简介
        is_instant_confirm: false, //是否开启闪订
        logo: "", //logoImg
        latitude: undefined, //纬度
        longtitude: undefined, //经度
        name: "", //门店名称
        operationTel: "", //运营电话
        ordernon_endtime: "", //结束时间
        ordernon_starttime: "00:00", //开始时间
        tel: "", //联系电话
        welcomes: "" //门店欢迎词
      };
      this.Isgo == true;
      this.getStoreList();
      this.$refs[formName].resetFields();
    },
    // 获取门店列表
    async getStoreList() {
      const { data: res } = await getStore(this.Store);
      this.tableData = res.rows;
    },
    // 查看按钮
    async LookBtn(e) {
      const { data: res } = await getStoreHid({ partnerHid: e.partner_hid });
      this.LookList = res.data;
      this.LookList.acceptBreachUser =
        res.data.acceptBreachUser == 1 ? true : false;
      this.LookList.active = res.data.active == 1 ? true : false;
      this.LookList.cancelWithoutDuty =
        res.data.cancelWithoutDuty == 1 ? true : false;
      this.LookList.hasFrontDesk = res.data.hasFrontDesk = 1 ? true : false;
      this.LookList.is_instant_confirm =
        res.data.is_instant_confirm == 1 ? true : false;
      this.dialogLook = true;
    },
    // 编辑按钮
    async compile(e) {
      this.title = "编辑门店";
      const { data: res } = await getStoreHid({ partnerHid: e.partner_hid });
      if (res.code !== 200) return;
      this.dialogVisible = true;
      this.formList.acceptBreachUser =
        res.data.acceptBreachUser == 1 ? true : false; //是否接待失信用户
      this.formList.active = res.data.active == 1 ? true : false; //是否上线
      this.formList.address = res.data.address || ""; //门店地址
      this.formList.cancelWithoutDuty =
        res.data.cancelWithoutDuty == 1 ? true : false; //是否支持30min无责取消
      this.formList.email = res.data.email || ""; //联系邮件
      this.formList.hasFrontDesk = res.data.hasFrontDesk == 1 ? true : false; //是否有前台
      this.formList.instruction = res.data.instruction || ""; //门店简介
      this.formList.is_instant_confirm =
        res.data.is_instant_confirm == 1 ? true : false; //是否开启闪订
      this.formList.logo = res.data.logo || ""; //logoImg
      this.formList.latitude = res.data.latitude || ""; //纬度
      this.formList.longtitude = res.data.longtitude || ""; //经度
      this.formList.name = res.data.name || ""; //门店名称
      this.formList.operationTel = res.data.operationTel || ""; //运营电话
      this.formList.ordernon_endtime =
        res.data.ordernon_endtime.slice(0, 5) || ""; //结束时间
      this.formList.ordernon_starttime =
        res.data.ordernon_starttime.slice(0, 5) || ""; //开始时间
      this.formList.tel = res.data.tel || ""; //联系电话
      this.formList.welcomes = res.data.welcomes || ""; //门店欢迎词
      if (res.data.logo) {
        this.vCoverPicSuccess.push({ url: res.data.logo });
      }
    },

    // 多选选中和取消
    Radio_btn() {
      console.log(1);
      // console.log(e);
      // console.log(this.Radio_list.indexOf(e) == -1);
      // if (this.Radio_list.indexOf(e) == -1) {
      // }
    },
    // // 删除部门
    // Delete() {
    //   this.open();
    // },
    // // 文字弹出确认框
    // open(e) {
    //   this.$confirm(`是否确认删除名称为""的数据项？`, "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning"
    //   })
    //     .then(async () => {})
    //     .catch(() => {
    //       this.$message({
    //         type: "info",
    //         message: "已取消删除"
    //       });
    //     });
    // },
    // 图片上传
    vCoverPicSuccessFour(response) {
      if (response.code !== 200)
        return this.$message({
          message:
            "图片格式错误，请删除图片，重新上传正确的图片格式（JPG,PNG）",
          type: "error"
        });
      console.log(response);
      this.formList.logo = response.msg;
      // if (this.tableData.vCoverPic.indexOf(response.msg) == -1) {
      // }
    },
    vCoverPicRemove(file, fileList) {
      this.formList.logo = "";
    },
    vCoverPicCardPreview(file) {
      console.log(file);
      this.vCoverPicLook = file.url;
      this.vCoverPicLook_img = true;
    },
    beforeAvatarUpload(file) {
      let isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 10MB!");
      }
      return isLt2M;
    },
    handlerBMap({ BMap, map }) {
      this.BMap = BMap;
      this.map = map;
      if (this.mapLocation.coordinate && this.mapLocation.coordinate.lng) {
        this.markers.lng = this.mapLocation.coordinate.lng;
        this.markers.lat = this.mapLocation.coordinate.lat;
        map.addOverlay(new this.BMap.Marker(this.mapLocation.coordinate));
      }
    },
    // 级联选择器click
    handleChange(value) {
      // this.formList.province = value[0];
      // this.formList.city = value[1];
      // this.formList.district = value[2];
      this.cityValue = value.join("");
      var cityValue = this.cityValue;
      this.address = this.cityValue;
      // if (value.length == 0) {
      //   this.cityValue = "中国";
      //   this.gainAddress(this.cityValue);
      //   this.zoom = 1;
      //   return;
      // }
      this.gainAddress(cityValue);
      this.zoom = 15;
    },
    // 搜索提示
    querySearch(queryString, cb) {
      var that = this;
      var myGeo = new this.BMap.Geocoder();
      myGeo.getPoint(
        queryString,
        function(point) {
          if (point) {
            that.mapLocation.coordinate = point;
            // that.makerCenter(point);
          } else {
            that.mapLocation.coordinate = null;
          }
        },
        this.locationCity
      );
      var options = {
        onSearchComplete: function(results) {
          console.log(results, 333);
          if (local.getStatus() === 0) {
            // 判断状态是否正确
            var s = [];
            for (var i = 0; i < results.getCurrentNumPois(); i++) {
              var x = results.getPoi(i);
              var item = { value: x.address + x.title, point: x.point };
              s.push(item);
              cb(s);
            }
          } else {
            cb();
          }
        }
      };
      var local = new this.BMap.LocalSearch(this.map, options);
      local.search(queryString);
    },
    // 获取地图经纬度
    gainAddress(cityValue) {
      this.$jsonp("https://api.map.baidu.com/geocoding/v3/", {
        address: cityValue,
        output: "json",
        ak: "gYOBOyROwCVTPTZavwZ6GumDClyRSjhB"
      })
        .then(res => {
          this.markers.lng = res.result.location.lng;
          this.markers.lat = res.result.location.lat;
          this.frameCenter = res.result.location;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 拖拽地图点位之后的经纬度
    getMapCenter(event) {
      this.formList.latitude = event.Ag.lat;
      this.formList.longtitude = event.Ag.lng;
    },
    // 级联选择器数据
    async getMapList() {
      var url = `https://restapi.amap.com/v3/config/district?keywords=${this.cityValue}&subdistrict=3&extensions=base&key=33b16f7c43c82d8c72312ec37969aaa2`;
      // var url = `https://api.map.baidu.com/api_region_search/v1/?keyword=${address}&sub_admin=3&ak=gYOBOyROwCVTPTZavwZ6GumDClyRSjhB&callback=showLocation`;
      axios.get(url).then(res => {
        this.cityOptions = this.getTreeData(res.data.districts[0].districts);
      });
    },
    /* 递归处理末尾项district为0的空项 */
    getTreeData(data) {
      // 循环遍历返回的数据
      for (var i = 0; i < data.length; i++) {
        if (data[i].districts.length < 1) {
          // districts若为空数组，则将districts设为undefined
          data[i].districts = undefined;
        } else {
          // districts若不为空数组，则继续 递归调用 本方法
          this.getTreeData(data[i].districts);
        }
      }
      return data;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisibleImg = true;
    },
    handleRemove(file) {
      console.log(file);
    },

    NewAddBtn() {
      this.title = "新建门店";
      this.dialogVisible = true;
    },
    handleClose(done) {
      done();
      this.vCoverPicSuccess = [];
      this.formList = {
        acceptBreachUser: false, //是否接待失信用户
        active: false, //是否上线
        address: "", //门店地址
        cancelWithoutDuty: false, //是否支持30min无责取消
        email: "", //联系邮件
        hasFrontDesk: false, //是否有前台
        instruction: "", //门店简介
        is_instant_confirm: false, //是否开启闪订
        logo: "", //logoImg
        latitude: undefined, //纬度
        longtitude: undefined, //经度
        name: "", //门店名称
        operationTel: "", //运营电话
        ordernon_endtime: "", //结束时间
        ordernon_starttime: "00:00", //开始时间
        tel: "", //联系电话
        welcomes: "" //门店欢迎词
      };
    },
    handleSelect(e) {
      this.formList.latitude = e.point.lat;
      this.formList.longtitude = e.point.lng;
      var cityValue = e.value;
      this.temporaryAddress = e.value;
      this.gainAddress(cityValue);
      this.zoom = 20;
    },
    // 地址弹出取消按钮
    dialogFormVisibleCancel(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    dialogFormVisibleBtn(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.formList.latitude == "" || this.formList.longtitude == "")
            return this.$message({
              message: "请移动地图上的标记点，确定位子",
              type: "error"
            });
          this.formList.address = this.temporaryAddress;
          this.dialogFormVisible = false;
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.NewAddBtn {
  padding: 0;
  width: 80px;
  height: 36px;
  background: #f6b439;
  border-radius: 4px;
  border: 1px solid #f6b439;
  margin-bottom: 30px;
}
/deep/.el-table th {
  text-align: center;
  background-color: #f2f2f2;
}
/deep/ .el-table__row td {
  text-align: center;
  height: 98px;
  padding: 4px 0;
}
/deep/.el-dialog__body {
  padding: 25px 44px;
}
.channel {
  width: 40rpx;
  height: 40rpx;
  image {
    width: 100%;
    height: 100%;
  }
}
/deep/.el-textarea {
  height: 100px;
}
/deep/.el-textarea__inner {
  height: 100px;
}
/deep/.el-cascader {
  height: 50px;
  width: 521px;
}
/deep/ .el-cascader .el-input {
  height: 40px;
  width: 100%;
  margin-right: 20px;
  .el-input__inner {
    height: 40px;
  }
}
.add_new_btn {
  width: 72px;
  height: 36px;

  background-color: #f6b439;
  border: 1px solid #f6b439;
}
.cancel {
  width: 72px;
  height: 36px;
  margin-right: 14px;
  background: #f2f2f2;
  border: 1px solid #e1e1e1;
}
.form_item {
  overflow: hidden;
  height: 50px;
  .form_item_title {
    float: left;
    height: 40px;
    margin: 5px 190px 20px 0px;
    color: #666666;
    span {
      color: #f6b439;
    }
  }
  .form_item_title:nth-child(2) {
    margin-right: 176px;
  }
}
.form_item_s {
  height: 80px;
  .form_item_title_s {
    float: left;
    height: 50px;
    margin: 5px 190px 20px 0px;
    color: #666666;
  }
}
.map {
  width: 100%;
  height: 400px;
}
/deep/.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 120px;
}
/deep/.el-form-item__label {
  font-size: 16px;
}
.upimg {
  position: relative;
  width: 100%;
  height: 150px;
  margin-bottom: 25px;
  .upimg_box {
    height: 150px;
    min-width: 150px;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}
/deep/.el-upload--picture-card {
  line-height: 150px;
  border-radius: 50%;
}
/deep/.el-upload-list--picture-card .el-upload-list__item {
  border-radius: 50%;
}
.RadioBox {
  width: 100%;
  height: 160px;
  margin-bottom: 20px;
  margin-left: 100px;
  margin-top: 20px;
  .Radio {
    // cursor: pointer;
    float: left;
    margin-right: 60px;
    width: 240px;
    height: 40px;
    border: 1px solid #e1e1e1;
    border-radius: 4px;
    margin-bottom: 20px;
    .Radio_left {
      float: left;
      margin: 7px 12px;
      // border-radius: 50%;
      width: 24px;
      height: 24px;
      border: 1px solid #dcdcdc;
    }
    .Radio_left_yes {
      float: left;
      margin: 7px 12px;
      // border-radius: 50%;
      width: 24px;
      height: 24px;
      border: 1px solid #f6b439;
      position: relative;
    }
    .Radio_left_yes::before {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      content: "";
      width: 10px;
      height: 10px;
      // border-radius: 50%;
      background-color: #f6b439;
    }
    .Radio_right {
      float: left;
      font-size: 16px;
      height: 21px;
      line-height: 21px;
      margin-top: 8px;
      color: #333333;
    }
  }
  .Radio:nth-child(2n) {
    margin-right: 0;
  }
}
/deep/.el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0;
}
.Radio_box {
  width: 100%;
  height: 160px;
  margin-bottom: 20px;
  // .Radio {
  //   cursor: pointer;
  //   float: left;
  //   margin-right: 60px;
  //   width: 240px;
  //   height: 40px;
  //   border: 1px solid #e1e1e1;
  //   border-radius: 4px;
  //   margin-bottom: 20px;
  //   .Radio_left {
  //     float: left;
  //     margin: 7px 12px;
  //     border-radius: 50%;
  //     width: 24px;
  //     height: 24px;
  //     border: 1px solid #dcdcdc;
  //   }
  //   .Radio_left_yes {
  //     float: left;
  //     margin: 7px 12px;
  //     border-radius: 50%;
  //     width: 24px;
  //     height: 24px;
  //     border: 1px solid #f6b439;
  //     position: relative;
  //   }
  //   .Radio_left_yes::before {
  //     position: absolute;
  //     top: 50%;
  //     left: 50%;
  //     transform: translate(-50%, -50%);
  //     content: "";
  //     width: 10px;
  //     height: 10px;
  //     border-radius: 50%;
  //     background-color: #f6b439;
  //   }
  //   .Radio_right {
  //     float: left;
  //     font-size: 16px;
  //     height: 21px;
  //     line-height: 21px;
  //     margin-top: 8px;
  //     color: #333333;
  //   }
  // }
  // .Radio:nth-child(2n) {
  //   margin-right: 0;
  // }
}
/deep/.el-checkbox.is-bordered {
  width: 240px;
  height: 40px;
  margin: 0;
  margin-right: 60px;
  margin-bottom: 20px;
}
/deep/.el-checkbox.is-bordered:nth-child(2n) {
  margin-right: 0;
}
/deep/.el-checkbox.is-bordered.is-checked {
  border-color: #f6b439;
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #f6b439;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #f6b439;
  border-color: #f6b439;
}
/deep/.el-checkbox__inner:hover {
  border-color: #f6b439;
}
.Storeimage {
  overflow: hidden;
  border-radius: 50%;
  width: 150px;
  height: 150px;
  margin-left: 50%;
  transform: translateX(-50%);
  img {
    width: 150px;
    height: 150px;
  }
}
.StoreName {
  margin-top: 25px;
  text-align: center;
  font-weight: bold;
  font-size: 24px;
}
.StoreInfo {
  width: 100%;
  overflow: hidden;
  margin-top: 30px;
  .StoreInfo_title {
    width: 100px;
    height: 21px;
    float: left;
    text-align: right;
  }
  .StoreInfo_message {
    float: left;
    width: 512px;
  }
}
</style>
